/*
 * Copyright (c) 2026. Orion Analytics
 */

import { useEffect, useState } from "react";
import { TrendingUp, TrendingDown } from "lucide-react";
import { fetchMarketMovers } from "../../api";
import { Link } from "react-router-dom";

export default function TopGainersLosers() {

    const [gainers, setGainers] = useState([]);
    const [losers, setLosers] = useState([]);

    useEffect(() => {

        fetchMarketMovers("NIFTY 200")
            .then((data) => {

                const stocks = data.stocks || [];

                const sorted = [...stocks]
                    .sort((a, b) => b.change - a.change);

                setGainers(sorted.slice(0, 8));

                setLosers(
                    [...sorted]
                        .reverse()
                        .slice(0, 8)
                );

            });

    }, []);

    return (

        <div className="grid md:grid-cols-2 gap-6">

            {/* GAINERS */}

            <div className="
                bg-white
                rounded-3xl
                border
                border-slate-200
                overflow-hidden
            ">

                <div className="
                    flex
                    items-center
                    gap-2
                    p-4
                    border-b
                    bg-emerald-50
                ">

                    <TrendingUp
                        size={18}
                        className="text-emerald-600"
                    />

                    <h3 className="
                        font-semibold
                        text-slate-900
                    ">
                        Top Gainers
                    </h3>

                </div>

                <table className="w-full">

                    <tbody>

                    {gainers.map((stock) => (

                        <tr
                            key={stock.name}
                            className="
                                border-b
                                border-slate-100
                                hover:bg-slate-50
                            "
                        >

                            <td className="px-4 py-3 font-medium">
                                <Link
                                    to={`/stock/${encodeURIComponent(stock.name)}`}
                                    onClick={() => window.scrollTo(0, 0)}
                                    className="
                                        inline-flex
                                        items-center
                                        gap-1
                                        text-blue-600
                                        hover:text-blue-800
                                        hover:underline
                                    "
                                >
                                    {stock.name}
                                    <span className="text-xs">↗</span>
                                </Link>
                            </td>

                            <td className="
                                px-4
                                py-3
                                text-right
                                font-semibold
                                text-emerald-600
                            ">
                                +{stock.change.toFixed(2)}%
                            </td>

                        </tr>

                    ))}

                    </tbody>

                </table>

            </div>

            {/* LOSERS */}

            <div className="
                bg-white
                rounded-3xl
                border
                border-slate-200
                overflow-hidden
            ">

                <div className="
                    flex
                    items-center
                    gap-2
                    p-4
                    border-b
                    bg-red-50
                ">

                    <TrendingDown
                        size={18}
                        className="text-red-600"
                    />

                    <h3 className="
                        font-semibold
                        text-slate-900
                    ">
                        Top Losers
                    </h3>

                </div>

                <table className="w-full">

                    <tbody>

                    {losers.map((stock) => (

                        <tr
                            key={stock.name}
                            className="
                                border-b
                                border-slate-100
                                hover:bg-slate-50
                            "
                        >

                            <td className="px-4 py-3 font-medium">
                                <Link
                                    to={`/stock/${encodeURIComponent(stock.name)}`}
                                    onClick={() => window.scrollTo(0, 0)}
                                    className="
                                        inline-flex
                                        items-center
                                        gap-1
                                        text-blue-600
                                        hover:text-blue-800
                                        hover:underline
                                    "
                                >
                                    {stock.name}
                                    <span className="text-xs">↗</span>
                                </Link>
                            </td>

                            <td className="
                                px-4
                                py-3
                                text-right
                                font-semibold
                                text-red-600
                            ">
                                {stock.change.toFixed(2)}%
                            </td>

                        </tr>

                    ))}

                    </tbody>

                </table>

            </div>

        </div>

    );

}